import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { inputsCustomizations } from './customizations/Inputs';
import { dataDisplayCustomizations } from './customizations/DataDisplay';
import { feedbackCustomizations } from './customizations/Feedback';
import { navigationCustomizations } from './customizations/Navigation';
import { surfacesCustomizations } from './customizations/Surfaces';
import { getDesignTokens } from './ThemePrimitives';
import { datePickersCustomizations } from './customizations/DatePicker';
import { useThemeMode } from '../context/ThemeModeContext';

export default function AppTheme(props) {
    const { children, disableCustomTheme, themeComponents } = props;
    const [themeVersion, setThemeVersion] = React.useState(0);
    const { mode } = useThemeMode();

    React.useEffect(() => {
        const handleThemeChange = () => {
            setThemeVersion(prev => prev + 1);
        };

        window.addEventListener('themeChanged', handleThemeChange);
        return () => window.removeEventListener('themeChanged', handleThemeChange);
    }, []);

    React.useEffect(() => {
        document.documentElement.setAttribute('data-mui-color-scheme', mode);
    }, [mode]);

    const theme = React.useMemo(() => {
        return disableCustomTheme
            ? {}
            : createTheme({
                cssVariables: {
                    colorSchemeSelector: 'data-mui-color-scheme',
                    cssVarPrefix: 'template',
                },
                ...getDesignTokens(mode),
                components: {
                    ...inputsCustomizations,
                    ...dataDisplayCustomizations,
                    ...feedbackCustomizations,
                    ...navigationCustomizations,
                    ...surfacesCustomizations,
                    ...themeComponents,
                    ...datePickersCustomizations,
                },
            });
    }, [disableCustomTheme, themeComponents, themeVersion, mode]);

    if (disableCustomTheme) {
        return <>{children}</>;
    }

    return (
        <ThemeProvider theme={theme} disableTransitionOnChange>
            {children}
        </ThemeProvider>
    );
}
